import type { IconProps } from '../types/IconProps.ts';
export const Eye: IconProps = {
    name: 'Eye',
    children: [
        `<circle cx="12" cy="12" r="3" />`,
        `<path d="M2 12C5 6.72 13.2-.68 22 12M22 12.02c-3 5.29-11.2 12.68-20 0" />`,
    ]
};